// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"a1271__index-module__dashboard","dashboardPage":"e8cd1__index-module__dashboard-page"};